<template>
  <div class="account-page">
    <div class="main-wrapper">
      <div class="account-content">
        <form @submit.prevent="submitForm" class="flex-fill">
          <div class="mx-auto mw-450">
            <div class="text-center mb-4">
              <img src="@/assets/img/logo.svg" class="img-fluid" alt="Logo" />
            </div>
            <div class="mb-4">
              <h4 class="mb-2 fs-20">Reset Password?</h4>
              <p>Enter New Password & Confirm Password to get inside</p>
            </div>
            <div class="mb-3">
              <label class="col-form-label">One Time Password</label>
              <div class="pass-group">
                <input
                  type="text"
                  v-model="form.otp"
                  class="pass-input form-control"
                />
              </div>
              <div class="emailshow text-danger" v-if="errorData.errors.otp">
                {{ errorData.errors.otp[0] }}
              </div>
            </div>
            <div class="mb-3">
              <label class="col-form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  v-model="form.password"
                  class="pass-inputs form-control"
                />
                <span
                  class="ti toggle-passwords"
                  :class="showPassword ? 'ti-eye' : 'ti-eye-off'"
                  @click="showPassword = !showPassword"
                  style="cursor: pointer"
                ></span>
              </div>
              <div
                class="emailshow text-danger"
                v-if="errorData.errors.password"
              >
                {{ errorData.errors.password[0] }}
              </div>
            </div>
            <div class="mb-3">
              <label class="col-form-label">Confirm Password</label>
              <div class="pass-group">
                <input
                  :type="showPasswordConfirm ? 'text' : 'password'"
                  v-model="form.password_confirmation"
                  class="pass-input-new form-control"
                />
                <span
                  class="ti toggle-password-new"
                  :class="showPasswordConfirm ? 'ti-eye' : 'ti-eye-off'"
                  @click="showPasswordConfirm = !showPasswordConfirm"
                  style="cursor: pointer"
                ></span>
              </div>
              <div
                class="emailshow text-danger"
                v-if="errorData.errors.password_confirmation"
              >
                {{ errorData.errors.password_confirmation[0] }}
              </div>
            </div>
            <div class="mb-3">
              <button
                type="submit"
                class="btn btn-primary w-100"
                :disabled="isLoading"
              >
                <span v-if="isLoading">
                  <span
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Submitting...
                </span>
                <span v-else> Change Password </span>
              </button>
            </div>
            <div class="mb-3 text-center">
              <h6>
                Return to
                <router-link to="/" class="text-purple link-hover">
                  Login</router-link
                >
              </h6>
            </div>
            <div class="text-center">
              <p class="fw-medium text-gray">Copyright &copy; 2024 - CRMS</p>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onMounted, reactive, ref } from "vue";
import { RouterLink, useRouter } from "vue-router";
import http from "@/utils/http";

const router = useRouter();

const form = reactive({
  otp: "",
  email: "",
  password: "",
  password_confirmation: "",
});

const isLoading = ref(false);
const showPassword = ref(false);
const showPasswordConfirm = ref(false);

onMounted(() => {
  form.email = localStorage.getItem("email");
});

const errorData = reactive({
  errors: {},
});

const submitForm = async () => {
  isLoading.value = true;
  try {
    const response = await http.post("/reset-password", {
      otp: form.otp,
      email: form.email,
      password: form.password,
      password_confirmation: form.password_confirmation,
    });

    if (response.status == 200) {
      console.log(response.status);
      router.push("/");
    }
  } catch (error) {
    errorData.errors = {};

    // Check if error response contains validation errors
    if (error.response && error.response.data && error.response.data.errors) {
      // Store validation errors in the reactive object
      errorData.errors = error.response.data.errors;
    } else {
      console.error("An unexpected error occurred.");
    }
  } finally {
    isLoading.value = false;
  }
};
</script>
